<template>
  <div>
    <el-container>
      <el-header>
        <Header></Header>
      </el-header>
      <div style="width:98%;margin:0 auto;padding:0;padding: 0">
        <Nav></Nav>
      </div>
      <!--select-->
      <div class="select-block">
        <el-form :inline="true" class="demo-form-inline">
          <el-row>
            <el-form-item>
              <el-select
                placeholder="请选择购机年份"
                v-model="choseYear"
                style="width: 160px"
                clearable
              >
                <el-option
                  v-for="(item, index) in buyYear"
                  :label="item"
                  :value="item"
                  :key="index"
                >
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item>
              <el-select
                placeholder="请选择资金年度"
                v-model="choseapplySubsidyTime"
                @change="changeChoseapplySubsidyTime"
                style="width: 160px"
                clearable
              >
                <el-option
                  v-for="(item, index) in applySubsidyTime"
                  :label="item.applySubsidyTime"
                  :value="item.applySubsidyTime"
                  :key="index"
                >
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item prop="cateThreeId">
              <el-select
                placeholder="请选择品目（资金年度必选）"
                v-model="cateThreeId"
                style="width: 220px"
                clearable
              >
                <el-option
                  v-for="(item, index) in listThreeCategory"
                  :label="item.dictName"
                  :value="item.dictKey"
                  :key="index"
                >
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item>
              <el-select
                placeholder="请选择补贴状态"
                v-model="choosesubsidyStatue"
                style="width: 160px"
                clearable
              >
                <!-- <el-option :value="20" label="公示">公示</el-option>
                <el-option :value="60" label="待审请结算">待审请结算</el-option>
                <el-option :value="80" label="待结算">待结算</el-option>
                <el-option :value="99" label="已结算">已结算</el-option> -->
                <el-option
                  v-for="(item,index) in subsidyStatue"
                  :label="item.dictName"
                  :value="item.dictKey"
                  :key="index"
                >
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="">
              <el-input
                v-model.trim="factoryCode"
                placeholder="请输入监控编号/出厂编号"
                style="width: 160px"
              ></el-input>
            </el-form-item>
            <!-- <el-form-item label="">
              <el-input
                v-model.trim="imei"
                placeholder="请输入监控编号"
                style="width: 100%"
              ></el-input>北京大屏-农机三合一补贴机具审核-补贴状态查询条件修改；
            </el-form-item> -->
            <el-form-item label="">
              <el-input
                v-model.trim="companyName"
                placeholder="请输入生产企业"
                style="width: 160px"
              ></el-input>
            </el-form-item>
            <el-form-item v-show="show">
              <el-select
                placeholder="请选择物联网设备"
                v-model="choseimei"
                style="width: 160px"
                clearable
              >
                <el-option
                  v-for="(item, index) in hasImei"
                  :label="item.label"
                  :value="item.value"
                  :key="index"
                >
                </el-option>
              </el-select>
            </el-form-item>
            
            <el-form-item>
              <el-button type="primary" @click="onSubmit">查询</el-button>
              <el-button type="primary" @click="exportExcel" style="margin-left: 10px">导出</el-button>
              <a type="primary" @click="show = !show" style="margin-left: 16px;color: #fff;">
                <a v-if="show" style="cursor: pointer;color: #fff;">收起</a>
                <a v-if="!show" style="cursor: pointercolor: #fff;">展开</a>
                <i :class="show ? 'el-icon-top' : 'el-icon-bottom'" />
              </a>
            </el-form-item>
          </el-row>
          <!--地区-->
          <div style="margin-top: 10px; ">
            <el-collapse-transition>
              <div v-show="show">
                <provCity :provCityId="provCityId" v-if="this.$store.state.Code === '11'"></provCity>
                <el-form-item label="">
                  <el-input
                    onfocus="this.placeholder=''"
                    onblur="this.placeholder='运行面积下限'"
                    v-model.trim="areaDown"
                    placeholder="运行面积下限"
                    style="width: 160px"
                  ></el-input><span style="color: #fff;">-</span>
                  <el-input
                    onfocus="this.placeholder=''"
                    onblur="this.placeholder='运行面积上限'"
                    v-model.trim="areaUp"
                    placeholder="运行面积上限"
                    style="width: 160px"
                  ></el-input>
                </el-form-item>
                <el-form-item>
                  <el-select
                    placeholder="请选择二维码"
                    v-model="choseqrcode"
                    style="width: 160px"
                    clearable
                  >
                    <el-option
                      v-for="(item, index) in qr_code"
                      :label="item.label"
                      :value="item.value"
                      :key="index"
                    >
                    </el-option>
                  </el-select>
                </el-form-item>
                 <!-- <el-form-item label="">
                  <el-input
                    v-model.trim="name"
                    placeholder="请输入机主姓名"
                    clearable
                  ></el-input>
                </el-form-item> -->
              </div>
            </el-collapse-transition>
          </div>
        </el-form>
      </div>
      <!--table-->
      <el-main style="padding:0;">
        <el-table :data="tableData">
          <el-table-column prop="id" label="序号" width="100" type="index">
            <template slot-scope="scope">
              <span>{{ (currentPage-1)*checkcurrentPage+parseInt(scope.$index)+1 }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="qrCode" label="二维码" width="80">
            <template slot-scope="scope">
              <el-popover placement="right" title="" trigger="hover">
                <img :src="scope.row.qrCode" class="code-img" />
                <img
                  slot="reference"
                  :src="scope.row.qrCode"
                  :alt="scope.row.qrCode"
                  style="max-height: 20px;max-width: 20px"
                />
              </el-popover>
            </template>
          </el-table-column>
          <el-table-column
            prop="name"
            label="机主"
            width="100"
            :show-overflow-tooltip="true"
            popper-class="tips"
          >
          </el-table-column>
          <el-table-column
            prop="catThreeName"
            label="补贴品目"
            :show-overflow-tooltip="true"
            popper-class="tips"
          >
          </el-table-column>
          <el-table-column
            prop="companyName"
            label="生产企业"
            :show-overflow-tooltip="true"
            popper-class="tips"
          >
          </el-table-column>
          <el-table-column
            prop="factoryCode"
            label="出厂编号"
            :show-overflow-tooltip="true"
            popper-class="tips"
          >
          </el-table-column>
          <el-table-column
            prop="imei"
            label="监控编号"
            :show-overflow-tooltip="true"
            popper-class="tips"
          >
          </el-table-column>
          <el-table-column
            prop="acreage"
            label="运行面积（亩）"
            :show-overflow-tooltip="true"
            popper-class="tips"
          >
            <template slot-scope="scope">
              <div v-if="scope.row.acreage !== ''">{{ scope.row.acreage}}</div>
            </template>
          </el-table-column>
          <el-table-column
            prop="subAddress"
            label="补贴地区"
            :show-overflow-tooltip="true"
            popper-class="tips"
          >
          </el-table-column>
          <el-table-column prop="applySubsidyTime" label="资金年度" width="100">
          </el-table-column>
          <el-table-column prop="buyTime" label="购机时间" width="100">
          </el-table-column>
          <el-table-column prop="subsidyName" label="补贴状态">
          </el-table-column>
          <el-table-column prop="address" label="操作" width="80">
            <template slot-scope="scope">
              <el-button type="text" size="small">
                <button
                  @click="golist(scope.row)"
                  style="color: #75c3ff;text-decoration: none;border: none;background: none;cursor: pointer"
                  v-if="scope.row.imei !== ''"
                >
                  查看
                </button>
                <!--<router-link :to="{name:'MonitorDetails',params:{imei:scope.row.imei}}"  style="color: #75c3ff;text-decoration: none">查看</router-link>-->
                <button
                  @click="noclick"
                  style="color: #767676;text-decoration: none;border: none;background: none;cursor: pointer"
                  v-else
                >
                  查看
                </button>
              </el-button>
            </template>
          </el-table-column>
        </el-table>
        <!--<div v-if="tableData&&tableData[0]"> </div>-->
        <div
          v-if="nodata"
          class="zanwu"
        >
          暂无数据
        </div>
        <div class="block">
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="currentPage"
            :page-size="checkcurrentPage"
            layout="total, prev, pager, next, jumper"
            :total="total"
            v-if="tableData && tableData[0]"
          >
          </el-pagination>
        </div>
      </el-main>
      <div v-if="isloading" class="">
        <div class="el-loading-spinner">
          <i class="el-icon-loading"></i>
          <p class="el-loading-text">拼命加载中</p>
        </div>
      </div>
    </el-container>
  </div>
</template>
<script>
import Api from "../../Serves/net-api.js";
import Http from "../../Serves/net-http.js";
import provCity from "../Index/common/provCity";
import Nav from "../../components/Index/nav";
import { mapState } from "vuex";
export default {
  name: "Monitor",
  components: { provCity, Nav },
  data() {
    return {
      nodata: false,
      isloading: true,
      loading: false, //表格加载状态
      provCityId: {
        cityCode: "",
        provCode: "",
        countyCode: ""
      }, //省市区组件id
      listThreeCategory: [],
      cateThreeId: "",
      factoryCode: "",
      companyName: "",
      areaDown: '',
      areaUp: '',
      imei: "",
      name: "",
      areastatus: false,
      status: "",
      monitorType: "",
      total: 1,
      totalRow: "",
      // tableData:null,
      freeNj: 0,
      num: 0,
      sportNj: 0,
      currentPage: 1,
      checkcurrentPage: 12,
      pageSize: "",
      formInline: {
        user: "",
        region: ""
      },
      token: "",
      value: "",
      options: [{}],
      tableData: [],
      choseYear: null,
      choseqrcode: null,
      choseimei: null,
      choosesubsidyStatue: null,
      choseapplySubsidyTime: new Date().getFullYear(),
      // buyYear: [{label:2020,value:2020},{label:2019,value:2019},{label:2018,value:2018}],
      buyYear: [],
      qr_code: [
        { label: "已生成", value: "yes" },
        { label: "未生成", value: "no" }
      ],
      hasImei: [
        { label: "已绑定", value: "yes" },
        { label: "未绑定", value: "no" }
      ],
      // applySubsidyTime: [{label:2020,value:2020},{label:2019,value:2019},{label:2018,value:2018}],
      applySubsidyTime: [],
      show: false,
      subsidyStatue: ""
    };
  },
  computed: {
    ...mapState({
      result: state => state.result
    })
  },
  mounted() {
    if (this.tableData.length == 0) {
      this.bus.$on("handleLotteryShare", val => {
        this.cateThreeId = "";
        this.status = "";
        this.factoryCode = "";
        this.companyName = "";
        this.monitorType = "";
        this.areaDown = ''
        this.areaUp = ''
        this.imei = "";
        this.name = "";
        this.currentPage = 1;
        this.checkcurrentPage = 12
        this.choseYear = null;
        this.choseqrcode = null;
        this.choseimei = null;
        this.choseapplySubsidyTime = new Date().getFullYear();
        this.choosesubsidyStatue = null;
        this.query();
        this.getYearNum()
        this.getlistThreeCategory(new Date().getFullYear());
        this.getListByType();
        this.getYear();
      });
      this.query();
      this.getYearNum()
      this.getlistThreeCategory(new Date().getFullYear());
      this.getListByType();
      this.getYear();
    }
    // this.getlistThreeCategory();
    // this.query();
  },
  beforeRouteLeave(to, from, next) {
    if (
      (to.path === "/MonitorDetails" && from.fullPath === "/Monitor") ||
      (to.path === "/MonitorDetails" && from.fullPath === "/Monitor")
    ) {
      from.meta.keepAlive = true;
    } else {
      from.meta.keepAlive = false;
      this.cateThreeId = "";
      this.status = "";
      this.factoryCode = "";
      this.companyName = "";
      this.monitorType = "";
      this.areaDown = ''
      this.areaUp = ''
      this.imei = "";
      this.name = "";
      this.currentPage = 1;
      this.checkcurrentPage = 11;
      this.choseYear = null;
      this.choseqrcode = null;
      this.choseimei = null;
      this.choseapplySubsidyTime = new Date().getFullYear();
      this.choosesubsidyStatue = null;
      this.query()
    }
    next();
  },
  methods: {
    getYear() {
      // var dd = new Date();
      // this.applySubsidyTime = [
      //   {
      //     label: dd.getFullYear(),
      //     value: dd.getFullYear()
      //   },
      //   {
      //     label: dd.getFullYear() - 1,
      //     value: dd.getFullYear() - 1
      //   },
      //   {
      //     label: dd.getFullYear() - 2,
      //     value: dd.getFullYear() - 2
      //   }
      // ];
      // this.buyYear = [
      //   {
      //     label: dd.getFullYear(),
      //     value: dd.getFullYear()
      //   },
      //   {
      //     label: dd.getFullYear() - 1,
      //     value: dd.getFullYear() - 1
      //   },
      //   {
      //     label: dd.getFullYear() - 2,
      //     value: dd.getFullYear() - 2
      //   }
      // ];
      var url=Http.test+'/subsidyMachine/getApplySubsidyTime'
        Api.doPost(url,null,false,(res)=>{
          this.applySubsidyTime = res.result
        },(doError)=>{
          console.log(doError)
        })
    },
    getYearNum () {
      var myDate = new Date()
      this.thisYear = myDate.getFullYear()
      var thisYear = myDate.getFullYear() // 获取当年年份
      var Section = thisYear - 2018 // 声明一个变量 获得当前年份至想获取年份差 eg.2008
      for (var i = 0; i <= Section; i++) {
        this.buyYear.push(thisYear--)
      } // 遍历并添加年份到数组
    },
    changeChoseapplySubsidyTime (value) {
      this.cateThreeId = ''
      if (value === '') {
        this.listThreeCategory = []
      } else {
        this.getlistThreeCategory(value)
      }
    },
    //补贴状态
    getListByType() {
      var url = Http.test + "/sysDict/getListByType";
      var parmse = { typeCode: "IS_SUBSIDY" };
      Api.doPost(
        url,
        parmse,
        false,
        res => {
          this.subsidyStatue = res.result.map(item => {
            if (item) return item;
          });
        },
        doError => {}
      );
    },
    golist(row) {
      this.$router.push({
        name: "MonitorDetails",
        params: { imei: row.imei, flag: 1, id: row.id }
      });
    },
    noclick() {
      this.$message("没有监控编号，无法查看");
    },
    //品目
    getlistThreeCategory(value) {
      // var url=Http.test+'/common/listThreeCategory'
      // var url = Http.test + '/dtIotNjData/getItemsByType'
      var url = Http.test + '/sysDict/getItemsByType'
      var parmse = {
        areaCode: this.result.areaCode,
        level: this.result.areaLevel,
        year: value
      };
      this.listThreeCategory = []
      Api.doPost(
        url,
        parmse,
        false,
        res => {
          res.result.forEach(item => {
            if (item) {
              this.listThreeCategory.push(item)
            }
          })
        },
        doError => {}
      );
    },
    //  获取列表数据
    onSubmit() {
      this.currentPage = 1
      this.nodata = false;
      this.isloading = true;
      this.query();
    },
    exportExcel () {
      var parmse = {
        provCode: this.provCityId.provCode,
        cityCode: this.provCityId.cityCode,
        countyCode: this.provCityId.countyCode,
        cateThreeId: this.cateThreeId,
        factoryCode: this.factoryCode,
        areaDown: this.areaDown,
        areaUp: this.areaUp,
        companyName: this.companyName,
        driverName: this.name,
        currentPage: this.currentPage,
        pageSize: this.checkcurrentPage,
        buyYear: this.choseYear,
        hasQrCode: this.choseqrcode,
        hasImei: this.choseimei,
        applySubsidyTime: this.choseapplySubsidyTime,
        subsidyCode: this.choosesubsidyStatue
      }
      Api.downloadFile(Http.test+'/subsidyMachine/exportMonitorNjList', '补贴机具审核导出数据.xls', 'application/vnd.ms-excel;charset=UTF-8', parmse)
    },
    // //查看
    handleClick(row) {
      this.$router.push({
        path: "/MonitorDetails",
        name: "MonitorDetails",
        params: { imei: row.imei }
      });
    },
    handleSizeChange(val) {
      this.checkcurrentPage = val;
      this.currentPage = 1;
      this.query();
    },
    //表格查询方法
    query() {
      var parmse = {
        provCode: this.provCityId.provCode,
        cityCode: this.provCityId.cityCode,
        countyCode: this.provCityId.countyCode,
        cateThreeId: this.cateThreeId,
        // status:this.status,
        factoryCode: this.factoryCode,
        areaDown: this.areaDown,
        areaUp: this.areaUp,
        companyName: this.companyName,
        // monitorType:this.monitorType,
        // factoryCode: this.imei,
        driverName: this.name,
        currentPage: this.currentPage,
        pageSize: this.checkcurrentPage,
        buyYear: this.choseYear,
        hasQrCode: this.choseqrcode,
        hasImei: this.choseimei,
        applySubsidyTime: this.choseapplySubsidyTime,
        subsidyCode: this.choosesubsidyStatue
      };
      this.loading = true;
      var url = Http.test + "/subsidyMachine/getMonitorNjList";
      Api.doPost(
        url,
        parmse,
        false,
        res => {
          this.loading = false;
          this.isloading = false;
          this.tableData = res.result.dataSource[0].monitorList;
          // this.tableData.length=0
          this.num = res.result.dataSource[0].num;
          this.freeNj = res.result.dataSource[0].freeNj;
          this.sportNj = res.result.dataSource[0].sportNj;
          this.total = res.result.totalRow;
          if (this.tableData.length == 0) {
            this.nodata = true;
          } else {
            this.nodata = false;
          }
          // this.subsidyStatue = res.result.dataSource.monitorList
        },
        doError => {
          console.log(doError);
        }
      );
    },
    //  分页
    handleCurrentChange(currentPage) {
      this.currentPage = currentPage;
      this.query();
    }
  }
};
</script>
<style scoped>
.zanwu{
  text-align: center;
  font-size: 44px;
  color:#999;
  width:100%;
  height: 600px;
  line-height: 600px;
}
.el-table__empty-text {
  display: block;
  width: 500px;
  height: 385px;
  padding-top: 300px;
  color: #909399;
  box-sizing: border-box;
}
.block{
  width: 100%;
  margin-top: 1vh;
  display: -webkit-box;
  -webkit-box-align: center;
  -webkit-box-pack: center;
  display: flex;
  align-items: center;
  justify-content: center;
}
.el-table{
  width: 98% !important;
  margin: auto;
  color: #fff;
}
.select-block {
  display: inline-block;
  padding: 0 20px;
  /*height: 40px;*/
  line-height: 40px;
  margin-top: 10px;
  width: 97%;
}
header {
  height: 0px !important;
}
form {
  display: inline-block;
}
.parameter {
  /*width: 100%;*/
  height: 85px;
  line-height: 85px;
  background: #101c4a;
  margin-bottom: 10px;
  width: 95%;
  margin: 10px auto 10px;
}
.parameter > div {
  margin-left: 30px;
  color: #75c3ff;
}
.parameter > div div {
  display: inline-block;
}

.parameter div span {
  display: inline-block;
  line-height: 40px;
}
.parameter > div div span:nth-child(2) {
  font-size: x-large;
  font-weight: bold;
  color: #fff;
  position: relative;
  top: 5px;
}
</style>



// WEBPACK FOOTER //
// src/components/TableList/Monitor.vue